import styled from 'styled-components';

interface ICollapsibleContainerProps {
  maxHeight: number;
  open: boolean;
}

interface IHorizontalCollapsibleContainerProps {
  maxWidth: number;
  open: boolean;
}

export const CollapsibleContainer = styled('div')<ICollapsibleContainerProps>`
  overflow: ${(props) =>
    props.showOverflow ? 'visible' : props.open ? 'auto' : 'hidden'};
  max-height: ${(props) => `${props.maxHeight}px`};
  transition: max-height 0.3s ease;
`;

export const HorizontalCollapsibleContainer = styled(
  'div'
)<IHorizontalCollapsibleContainerProps>`
  overflow: ${(props) => (props.open ? 'visible' : 'hidden')};
  max-width: ${(props) => `${props.maxWidth}px`};
  transition: max-width 0.3s ease;
`;

export const CollapsibleChildren = styled('div')`
  padding: 1rem;
`;

export const HorizontalCollapsibleChildren = styled('div')`
  padding: 0;
`;
